import { createReducer, on } from "@ngrx/store";
import { ProductsActions } from "./products.actions";
import { Plans } from "../../models/products.models";
import { TokensPack } from "../../class/tokensPack.class";

export interface ProductsState {
    plans: Plans | undefined,
    tokensPacks: TokensPack[] | undefined

}

export const initialState: Readonly<ProductsState> = {
    plans: undefined,
    tokensPacks: []
};

export const ProductsReducers = createReducer(
    initialState,
    on(ProductsActions.addProducts, (state, { plans, tokensPacks }) => {
        return {
            ...state,
            plans: plans,
            tokensPacks: tokensPacks
        }
    }),
)